import { combineReducers } from 'redux';
import app from './app';

export default combineReducers({
	app,
	metaLayer: (state = {}) => state
});



// WEBPACK FOOTER //
// ./client/reducers/index.js